import React from 'react';
import { useAppointmentModal } from '../context/AppointmentModalContext';
import { useI18n } from '../i18n/I18nContext';
import './ClosingCta.css';

function ClosingCta() {
  const { openModal } = useAppointmentModal();
  const { copy } = useI18n();

  return (
    <section className="michaela-closing-cta" aria-label={copy.home.closingAria}>
      <div className="michaela-closing-cta-inner">
        <p className="michaela-closing-cta-text">
          {copy.home.closing}
        </p>
        <button
          type="button"
          className="michaela-closing-cta-button"
          onClick={openModal}
        >
          {copy.home.cta}
        </button>
      </div>
    </section>
  );
}

export default ClosingCta;
